
<template>
  <span v-if="datas" class="tagWrap">
    <span
      class="tag-img"
      :class="datas.mktFrontType ? 'tag' + datas.mktFrontType : '' "
      v-if="datas.mktIcon && datas.mktFrontType == 9007"
    >
      <img :src="datas.mktIcon" alt="">
    </span>
    <span
      class="single-tag"
      :class="datas.mktFrontType ? 'tag' + datas.mktFrontType : '' "
      :style="getCss(datas)"
      v-else
    >{{ getText(datas) }}</span>
  </span>
</template>

<script>
export default {
  name: "SingleTag",
  props: {
    datas: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getCss(val) {
      if (!val) {
        return null;
      }
      const type = Number(val.mktFrontType);
      let cssJson = {};
      if (type) {
        switch(type){
          case 1001: // 特价
            // cssJson = { color: '#F75E35', border: '1px solid #f65739' };
            break;
          case 1004: // 抢购
            // cssJson = { color: '#F75E35', border: '1px solid #F75E35' };
            break;
          case 9001: // 新品
            // cssJson = { color: '#60BF1D', border: '1px solid #60BF1D' };
            break;
          case 2001: // 满减
            // cssJson = { color: '#f75e35', border: '1px solid #f75e35' };
            break;
          case 9003: // 限购
            // cssJson = { minWidth: '48px', width: 'auto', color: '#F75E35', lineHeight: '18px', border: 'none', background: 'linear-gradient(192deg, rgba(255, 175, 0, 0.1) 0%, rgba(244, 69, 69, 0.1) 100%)' }
            break;
          case 9004: // 起购
            // cssJson = { minWidth: '48px', width: 'auto', color: '#F75E35', lineHeight: '18px', border: 'none', background: 'linear-gradient(192deg, rgba(255, 175, 0, 0.1) 0%, rgba(244, 69, 69, 0.1) 100%)' }
            break;
          case 9005: // 频道名称
            // cssJson = { minWidth: '24px', width: 'auto', padding: '0 4px', color: val.fontColor, border: 'none', background: val.backgroundColor };
            cssJson = { color: val.fontColor, background: val.backgroundColor };
            break;
          case 9006: // 运营标签
            // cssJson = { minWidth: '24px', width: 'auto', padding: '0 4px', color: val.fontColor, border: 'none', background: val.backgroundColor };
            cssJson = { color: val.fontColor, background: val.backgroundColor };
            break;
          case 90061: // 推荐标签
            // cssJson = { minWidth: '24px', width: 'auto', padding: '0 4px', color: val.fontColor, border: 'none', background: val.backgroundColor };
            cssJson = { color: val.fontColor, background: `${val.backgroundColor + ' url("https://fecdn.dongfangfuli.com/mall/images/recommd_tag.png") 2px center no-repeat'}`, backgroundSize: '12px auto' };
            break;
          case 90062: // 复购标签
            // cssJson = { minWidth: '24px', width: 'auto', padding: '0 4px', color: val.fontColor, border: 'none', background: val.backgroundColor };
            cssJson = { color: val.fontColor, background: val.backgroundColor };
            break;
          case 9007: // 体检自营标签
            // cssJson = { minWidth: '24px', width: 'auto', padding: '0 4px', color: val.fontColor, border: 'none', background: val.backgroundColor };
            cssJson = { color: val.fontColor, background: val.backgroundColor };
            break;
          case 300001: // 抽奖
            // cssJson = { color: '#FF5757', border: '1px solid #FF5757' };
            break;
        }
      } else if (val.name) {
        cssJson = { color: '#FF6600', border: '1px solid #FF6600' };
      }
      return cssJson;
    },
    getText(val) {
      if (!val) {
        return null;
      }
      const type = Number(val.mktFrontType);
      let str = "";
      if (type) {
        switch(type){
          case 1001: // 特价
            str = "特价";
            break;
          case 1004: // 抢购
            str = "抢购";
            break;
          case 9001: // 新品
            str = "新品";
            break;
          case 2001: // 满减
            str = "满减";
            break;
          case 9003: // 限购
            str = val.mktText;
            break;
          case 9004: // 起购
            str = val.mktText;
            break;
          case 9005: // 频道名称
            str = val.mktText;
            break;
          case 9006: // 运营标签
            str = val.mktText;
            break;
          case 90061: // 复购标签
            str = val.mktText;
            break;
          case 90062: // 推荐标签
            str = val.mktText;
            break;
          case 9007: // 体检自营标签
            str = val.mktText;
            break;
          case 300001: // 抽奖
            str = "抽奖";
            break;
        }
      } else if (val.name) {
        str = val.name;
      }
      return this.TLang(str, "cart");
    },
  },
};
</script>

<style lang="less" scoped>
@375: 320/375;
.single-tag {
  display: block;
  // min-width: 32px * @375;
  width: auto;
  padding: 1.5px * @375 2px * @375 1px * @375;
  // height: 16px * @375;
  height: auto;
  border-radius: 2px * @375;
  // line-height: 16px * @375;
  line-height: 1;
  box-sizing: border-box;
  text-align: center;
  font-size: 12px * @375;
  margin-top: 0;
  color: #FF6600;
  border: 1px * @375 solid rgba(255, 102, 0, 0.8);
  margin-right: 2px * @375;
}
.tag-img {
  line-height: 0;
  img {
    height: 16px * @375;
    width: auto;
    max-width: 100%;
  }
}
.tag1001 {
  color: #FF6600;
  border: 1px * @375 solid rgba(255, 102, 0, 0.8);
  padding: 1.5px * @375 2px * @375 1px * @375;
  // min-width: 35px * @375;
}
.tag1004 {
  color: #FF6600;
  border: 1px * @375 solid rgba(255, 102, 0, 0.8);
  padding: 1.5px * @375 2px * @375 1px * @375;
  // min-width: 35px * @375;
}
.tag9001 {
  color: #56CC08;
  border: 1px * @375 solid #56CC08;
  padding: 1.5px * @375 2px * @375 1px * @375;
}
.tag2001 {
  color: #FF6600;
  border: 1px * @375 solid rgba(255, 102, 0, 0.8);
  padding: 1.5px * @375 2px * @375 1px * @375;
}
.tag9003, .tag9004 {
  // min-width: 47px * @375;
  width: auto;
  // height: 16px * @375;
  // line-height: 16px * @375;
  height: auto;
  line-height: 1;
  color: #A037E5;
  border: 1px solid #A037E5;
  padding: 1.5px * @375 2px * @375 1px * @375;
}
.tag9005, .tag9006{
  display: inline-block;
  // min-width: 35px * @375;
  width: auto;
  height: 14px * @375;
  line-height: 14px * @375;
  border: none;
  border-radius: 2px * @375;
  font-size: 10px * @375;

  font-weight: 400;
  margin-right: 2px * @375;
  padding: 0 2px * @375;
  max-width: 100%;
}
.tag90061 {
  border: none;
  // background: #FFF5F3;
  color: #FF6600;
  line-height: 1;
  padding: 2px * @375;
  font-size: 12px * @375;
  padding-left: 15px * @375;
  background:#FFF5F3 url('https://fecdn.dongfangfuli.com/mall/images/recommd_tag.png') 2px * @375 center no-repeat;
  background-size: 12px * @375 auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 2px * @375;
}
.tag90062 {
  border: none;
  background: #FFFBF3;
  color: #C29C4A;
  line-height: 1;
  padding: 2px * @375;
  font-size: 12px * @375;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 2px * @375;
}
.tag300001 {
  color: #FF6600;
  border: 1px * @375 solid rgba(255, 102, 0, 0.8);
  padding: 1.5px * @375 2px * @375 1px * @375;
}
.tagPrizeGoods {
  display: inline-block;
  width: auto;
  height: auto;
  line-height: 10px * @375;
  border-radius: 2px * @375;
  font-size: 10px * @375;

  font-weight: 500;
  margin-right: 2px * @375;
  padding: 2px * @375 1px * @375;
  min-width: 26px * @375;
  text-align: center;
  box-sizing: border-box;
}
.tagCartLottery {
  display: inline-block;
  width: auto;
  height: 16px * @375;
  border-radius: 2px * @375;
  line-height: 16px * @375;
  box-sizing: border-box;
  font-size: 12px * @375;

  font-weight: 400;
  margin-right: 2px * @375;
  padding: 0 4px * @375;
  color: #FF6600;
  border: 1px * @375 solid rgba(255, 102, 0, 0.8);
  span {
      font-size: 12px * @375;
  }
}
</style>